export default "__VITE_PUBLIC_ASSET__d45af500__"